// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3441) return "static/chunks/3441-050c4aace6102992.js";
	if (chunkId === 8751) return "static/chunks/8751-c80829fe61cf3838.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"376":"c3343368b267214f","1132":"0d705b0c5e5e3521","4230":"cbafbdc7a4760c0a","4290":"af76dc5575d69422","4368":"c085d25159133918","4593":"2f52e9222180a0ba","6974":"96c72fd373938c3b"}[chunkId] + ".js";
};